import React from 'react'
import Media from 'react-media'

import FindYourCar from '@cinch/oxd-components/find-your-car/src'
import { EstatesIcon } from '@cinch/oxd-components/find-your-car/src'
import { CoupesIcon } from '@cinch/oxd-components/find-your-car/src'
import { ConvertiblesIcon } from '@cinch/oxd-components/find-your-car/src'
import { SuvsIcon } from '@cinch/oxd-components/find-your-car/src'
import { HatchbacksIcon } from '@cinch/oxd-components/find-your-car/src'
import Articles from '@cinch/oxd-components/homepage-articles/src'
import { Article } from '@cinch/oxd-components/homepage-articles/src/homepage-articles.component'
import IconList from '@cinch/oxd-components/icon-list/src'
import { Binoculars } from '@cinch/oxd-components/icons/src'
import Link, { Appearance, Size } from '@cinch/oxd-components/link/src'
import SVG from '@cinch/oxd-components/svg/src'
import ValuationInput from '@cinch/oxd-components/valuation-input-panel/src'
import Wrapper from '@cinch/oxd-components/wrapper/src'
import Layout from '@cinch/oxd-layouts/regular/src'
import GlobalContext from '@cinch/oxd-utils/context/src'
import tokens from '@cinch/oxd-utils/tokens/src'
import HomeHero from './components/home-hero'

import OurCommitmentCta from './assets/our-commitment-cta.png'

import * as styles from './home.module.css'

interface HomepageProps {
  i18n: Pick<Cinch.WebAppTranslations, 'home' | 'findYourCar' | 'valuationModule'>
  heroImage: any
  articles: Article[]
}

const BULLET_KEYS = ['bullet1', 'bullet2', 'bullet3', 'bullet4']

const FIND_YOUR_CAR_ITEMS = [
  { icon: SuvsIcon, label: 'SUVs', value: 'suvs', url: '/find-vehicle?bodyType=suv' },
  { icon: CoupesIcon, label: 'Coupes', value: 'coupes', url: '/find-vehicle?bodyType=coupe' },
  { icon: EstatesIcon, label: 'Estates', value: 'estates', url: '/find-vehicle?bodyType=estate' },
  { icon: HatchbacksIcon, label: 'Hatchbacks', value: 'hatchbacks', url: '/find-vehicle?bodyType=hatchback' },
  { icon: ConvertiblesIcon, label: 'Convertibles', value: 'convertibles', url: '/find-vehicle?bodyType=convertible' },
]

const Homepage: React.FC<HomepageProps> = ({ i18n, heroImage, articles }) => {
  const i18nHome = i18n.home
  const i18nFindYourCar = i18n.findYourCar

  const ourCommitment = (
    <div className={styles.headerCta}>
      <Media query={tokens.customMedia.m}>
        <h4 className={styles.headerCtaTitle}>{i18nHome.ourCommitmentTitle}</h4>
      </Media>
      <div className={styles.headerCtaSplit}>
        <div className={styles.headerCtaSplitImage}>
          <img
            className={styles.headerCtaImage}
            src={typeof OurCommitmentCta === 'string' ? OurCommitmentCta : ''}
            alt=""
          />
          <Media query={tokens.customMedia.m}>
            {(matches) => !matches && <h4 className={styles.headerCtaTitle}>{i18nHome.ourCommitmentTitleMobile}</h4>}
          </Media>
        </div>
        <GlobalContext.Consumer>
          {({ ourCommitmentModule }: Cinch.Context) => (
            <div className={styles.headerCtaSplitContent}>
              <IconList
                className={styles.headerCtaIconList}
                bulletText={BULLET_KEYS.map((bullet) => ourCommitmentModule[bullet])}
                hasGradient={true}
                gradientId={'bravo'}
              />
            </div>
          )}
        </GlobalContext.Consumer>
      </div>
      <Link
        to={'/our-commitment'}
        size={Size.mini}
        appearance={Appearance.tertiaryButton}
        className={styles.headerCtaButton}
      >
        {i18nHome.ourCommitmentButton}
      </Link>
    </div>
  )

  const helpMeChoose = (
    <div className={styles.headerCta}>
      <Media query={tokens.customMedia.m}>
        <h4 className={styles.headerCtaTitle}>{i18nHome.helpMeChooseTitle}</h4>
      </Media>
      <div className={styles.headerCtaSplit}>
        <div className={styles.headerCtaSplitImage}>
          <SVG className={styles.headerCtaImage} children={Binoculars} />
        </div>
        <div className={styles.headerCtaSplitContent}>
          <Media query={tokens.customMedia.m}>
            {(matches) => !matches && <h4 className={styles.headerCtaTitle}>{i18nHome.helpMeChooseTitle}</h4>}
          </Media>
          <p>{i18nHome.helpMeChooseBody}</p>
        </div>
      </div>
      <Link
        to={'/lifestyle/budget'}
        size={Size.mini}
        appearance={Appearance.tertiaryButton}
        className={styles.headerCtaButton}
      >
        {i18nHome.helpMeChooseButton}
      </Link>
    </div>
  )

  return (
    <Layout isFluid={true} hasBleed={true}>
      <HomeHero i18n={i18nHome} heroImage={heroImage} />

      <section className={styles.headerCtasContainer}>
        {helpMeChoose}
        {ourCommitment}
      </section>

      <Wrapper>
        <section className={styles.findYourCarSection}>
          <h2 className={styles.sectionHeading}>{i18nHome.findYourCar}</h2>
          <FindYourCar i18n={i18nFindYourCar} items={FIND_YOUR_CAR_ITEMS} allCarsUrl="/find-vehicle" />
        </section>
        <section className={styles.valuationSection}>
          <Media query={tokens.customMedia.m}>
            {(matches) => <ValuationInput isWide={matches} i18n={i18n.valuationModule} />}
          </Media>
        </section>
      </Wrapper>

      <section className={styles.articlesSection}>
        <Wrapper>
          <Articles i18n={i18nHome.articles} ctaLink={'/guides'} articles={articles} />
        </Wrapper>
      </section>
    </Layout>
  )
}

export default Homepage
